import { TranslatableText } from '@dreryk/react-common';
import { Modal, ModalMaxHeight, ModalWidth, TestId } from '@dreryk/react-components';

import { FormsTemplatesDisplayContextProvider } from '../displayContext/formsTemplatesDisplayContext';

type FormsTemplatesModalProps = {
   readonly title: TranslatableText;
   readonly testId: TestId;
   readonly children: JSX.Element;
   readonly disableScroll?: boolean;
   readonly width?: ModalWidth;
};

export const FormsTemplatesModal = (props: FormsTemplatesModalProps): JSX.Element => {
   return (
      <FormsTemplatesDisplayContextProvider value={'MODAL'}>
         <Modal
            testId={props.testId}
            title={props.title}
            width={props.width ?? ModalWidth.HUGE}
            height={ModalMaxHeight.TALL}
            disableScroll={props.disableScroll}
         >
            {props.children}
         </Modal>
      </FormsTemplatesDisplayContextProvider>
   );
};
